import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Store } from '@ngxs/store'
import { LoggedIn } from '../../../../core/stores/auth/auth.actions'
import { LoginResponse } from '../../../../core/models/login-response.model'

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
})
export class RedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store
  ) {
    // On écoute les query params de la redirection
    this.route.queryParams.subscribe((params) => {
      if (params['email'] && params['token']) {
        // Construction de l'objet loginResponse compatible avec LoginResponse

        // Mise à jour du state via NGXS : on dispatch l'action LoggedIn avec le token
        this.store.dispatch(
          new LoggedIn({
            accessToken: params['token'],
            tokenType: 'Bearer',
            expireIn: 3600,
          })
        )
        // Redirection vers le dashboard
        this.router.navigate(['/home'])
      }
    })
  }

  ngOnInit() {}
}
